import React from 'react';
import { Eye, MessageSquare } from 'lucide-react';
import { trackWhatsAppClick, trackModelView } from '../services/adminStorage';
import { getFormattedDemoUrl } from './ModelPreviewModal';

export default function ModelCard({ model, onSelectModel }) {
  const rawDemoUrl = model.demoUrl || model.demo_url || '';
  const demoUrl = getFormattedDemoUrl(rawDemoUrl);

  const handleQuote = (e) => {
    e.stopPropagation();
    trackWhatsAppClick(model.id);
    const message = encodeURIComponent(`Olá, Suzume Technologies! Gostaria de solicitar um orçamento para a landing page do modelo: "${model.name}" (Categoria: ${model.category}).`);
    window.open(`https://wa.me/5511932654166?text=${message}`, '_blank');
  };

  const handleSelect = () => {
    trackModelView(model.id);
    onSelectModel(model);
  };

  return (
    <div className="model-card">
      <div 
        className="model-card-thumb" 
        style={{ 
          background: model.gradient || 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)',
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <span className="model-card-badge" style={{ zIndex: 2 }}>{model.category}</span>
        
        {demoUrl ? (
          <div style={{
            width: '88%',
            height: '150px',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
            border: '1px solid rgba(255,255,255,0.25)',
            position: 'relative',
            background: '#ffffff',
            zIndex: 1
          }}>
            <iframe 
              src={demoUrl} 
              title={model.name} 
              style={{
                width: '1280px',
                height: '800px',
                border: 'none',
                transform: 'scale(0.24)',
                transformOrigin: 'top left',
                pointerEvents: 'none',
                position: 'absolute',
                top: 0,
                left: 0
              }} 
            />
          </div>
        ) : (
          <div style={{
            background: 'rgba(255, 255, 255, 0.15)',
            backdropFilter: 'blur(8px)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '12px',
            padding: '1.25rem 1.5rem',
            textAlign: 'center',
            width: '85%',
            boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
            zIndex: 1
          }}>
            <div style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.1em', opacity: 0.9 }}>Preview Mockup</div>
            <div style={{ fontSize: '1.1rem', fontWeight: 700, marginTop: '0.25rem' }}>{model.name}</div>
          </div>
        )}
      </div>

      <div className="model-card-content">
        <div style={{ marginBottom: '0.5rem' }}>
          <h3 className="model-card-title">{model.name}</h3>
        </div>

        <p className="model-card-desc">{model.description}</p>

        <div className="model-tags">
          {model.tags && model.tags.map((tag, idx) => (
            <span key={idx} className="model-tag">#{tag}</span>
          ))}
        </div>

        <div className="model-card-footer">
          <button 
            className="btn btn-secondary btn-sm" 
            onClick={handleSelect}
            title="Ver modelo detalhado"
          >
            <Eye size={16} />
            <span>Ver modelo</span>
          </button>
          <button 
            className="btn btn-whatsapp btn-sm" 
            onClick={handleQuote}
            title="Solicitar orçamento via WhatsApp"
          >
            <MessageSquare size={16} />
            <span>Solicitar orçamento</span>
          </button>
        </div>
      </div>
    </div>
  );
}
